<template>
  <section class="_ptxs _pbm">
    <div container>
      <async-loader v-if="paymentHistoryLoading"/>
      <div v-else class="card" grid="row wrap">
        <div column="xs-6 s-5 m-3">
          <label>Amount Paid:</label>
          <h2>{{toDollarFormat(totalAmount)}}</h2>
        </div>
        <div column="xs-6 s-7 m-9" class="_p0">
          <div grid="row wrap">
            <div column="xs-12 s-6 m-4" class="_pbxs">
              <label>Payment Date:</label>
              {{formatDate(new Date())}}
            </div>
            <div column="xs-12 s-6 m-4" class="_pbxs">
              <label>Payment Method:</label>
              {{ paymentMethod }}
            </div>
            <div column="xs-12 s-6 m-4" class="_pbxs">
              <label>Confirmation Number:</label>
              {{ confirmationNumber }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import billing from '@mixins/billing'
  import formattable from '@mixins/formattable'
  import AsyncLoader from '../../../components/molecules/AsyncLoader'

  export default {
    components: { AsyncLoader },
    mixins: [billing, formattable],
    computed: {
      onetimePayment () {
        return this.$route.query.paymentId
      },
      confirmationNumber () {
        return this.onetimePayment ? this.$route.query.paymentId : this.payment.transactionId
      },
      paymentMethod () {
        if (this.onetimePayment) {
          return 'onetime payment'
        } else {
          return `${this.payment.paymentType} (${this.payment.paymentLastFour})`
        }
      },
      totalAmount () {
        return this.paymentHistory.reduce((sum, ph) => sum + Number.parseFloat(ph.paidAmt), 0.00)
      }
    }
  }
</script>

<style scoped lang="scss">
  .card {
    margin: 0;
    padding: 2rem 1.5rem;
  }
  h2 {
    margin: 0;
  }
  .flex-wrap {
    align-items: center;
    .btn {
      margin-left: auto;
  }
    border-bottom: 1px solid $color-border;
  }
</style>
